export type ProposalType = 'A' | 'B' | 'C' | 'D'

export type ModuleId = 'M1' | 'M2' | 'M3' | 'M4' | 'M5' | 'M6'

export type InhouseLevel = 'only' | 'support' | 'system'

export interface Answers {
  Q1: string
  Q2: string[]
  Q3: string[]
  Q4: string[]
  Q5: string[]
  Q6: string
  Q7: string
  Q8: string
  Q9: string
  Q10: string
  Q11: string[]
  Q12: string
  Q13: string
  Q14: string
}

// BizCurriculumTopic (Rails) から渡ってくる講座マスタ。
export interface CurriculumTopic {
  id: number
  program: string
  title: string
  url_name: string
}

export interface CurriculumItem {
  order: number
  name: string
  aim: string
  count: number | null
  countLabel?: string // "継続" 等、数値で表せない場合の表示用ラベル
  prep?: boolean
  urlName?: string
}

export interface InhouseJudgement {
  level: InhouseLevel
  text: string
  reason: string
}

export interface JudgeResult {
  type: ProposalType
  typeName: string
  modules: ModuleId[]
  curriculum: CurriculumItem[]
  totalSessions: number
  duration: string
  inhouse: InhouseJudgement
}

export const TYPE_NAMES: Record<ProposalType, string> = {
  A: 'ピンポイント強化型',
  B: '体系習得型',
  C: '伴走・実践型',
  D: '組織育成型',
}

export function createEmptyAnswers(): Answers {
  return {
    Q1: '',
    Q2: [],
    Q3: [],
    Q4: [],
    Q5: [],
    Q6: '',
    Q7: '',
    Q8: '',
    Q9: '',
    Q10: '',
    Q11: [],
    Q12: '',
    Q13: '',
    Q14: '',
  }
}
